module.exports = __webpack_public_path__ + "static/media/bad-dream.40e078ab.jpg";